import { useEffect, useState } from "react";
import { StickyNote, Trash2, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import api from "@/lib/api";

const fmt = (iso) => new Date(iso).toLocaleString("it-IT", { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export const CustomerNotes = ({ customerId }) => {
  const [notes, setNotes] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.customerNotes(customerId).then(setNotes).catch(() => {}); }, [customerId]);
  const add = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try {
      const n = await api.addCustomerNote(customerId, text);
      setNotes([n, ...notes]); setText("");
      toast.success("Nota aggiunta");
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); } finally { setBusy(false); }
  };
  const del = async (id) => {
    try { await api.deleteCustomerNote(customerId, id); setNotes(notes.filter((n) => n.id !== id)); toast.success("Nota eliminata"); } catch { toast.error("Errore"); }
  };
  return (
    <div data-testid="customer-notes">
      <h3 className="text-sm font-semibold mb-2 flex items-center gap-2"><StickyNote className="h-4 w-4 text-amber-400" /> Note interne <span className="text-xs text-muted-foreground font-normal">(non visibili al cliente)</span></h3>
      <div className="flex gap-2 items-start">
        <Textarea data-testid="customer-note-input" value={text} onChange={(e) => setText(e.target.value)} placeholder="Aggiungi una nota…" rows={2} className="bg-card border-border" />
        <Button data-testid="customer-note-add" onClick={add} disabled={busy || !text.trim()} size="icon" title="Aggiungi nota"><Send className="h-4 w-4" /></Button>
      </div>
      <div className="space-y-2 mt-3">
        {notes.length === 0 && <p className="text-xs text-muted-foreground">Nessuna nota</p>}
        {notes.map((n) => (
          <div key={n.id} className="rounded-lg border border-border bg-card p-3 text-sm flex gap-2" data-testid={`customer-note-${n.id}`}>
            <div className="flex-1"><p className="whitespace-pre-wrap">{n.text}</p><p className="text-xs text-muted-foreground mt-1">{n.author} · {fmt(n.created_at)}</p></div>
            <Button variant="ghost" size="icon" className="h-7 w-7 text-red-400 hover:text-red-300" onClick={() => del(n.id)} data-testid={`customer-note-delete-${n.id}`}><Trash2 className="h-3.5 w-3.5" /></Button>
          </div>
        ))}
      </div>
    </div>
  );
};
